// Third Party Imports
import React, {Component} from 'react';

// Relative Imports
import '../../utils.less';
import {log} from '../../api/logger';

class ListingPageAll extends Component {
    constructor(props) {
        super(props);

        this.loaded = false;
        this.state = {};
    }

    componentDidMount() {
        const {coldStartUser, triggerEdapEvent} = this.props;
        this.loaded = true;
        if (coldStartUser) {
            triggerEdapEvent('generic.event', {
                eventaction: 'cold-start-visitor',
                eventcategory: 'visitor-type'
            });
        }
    }

    componentDidUpdate() {
        /**
         * Prefetch correct ListingPage bundle first and then do re-rendering
         * Prevents screen to go blank and preserves scroll position
         */
        const {system} = this.props;
        const {isMobile, useListingPageLite} = system;

        if (isMobile && useListingPageLite && !this.ListingPageMobileLite) {
            /* istanbul ignore next */
            import('../ListingPage/ListingPageMobileLite')
                .then((component) => {
                    this.ListingPageMobileLite = component.default;
                    this.setState({mobileLiteLoaded: true});
                })
                .catch((error) => {
                    log({
                        error: `Failed to load ListingPageMobileLite. Error Message: ${
                            error.message
                        }`
                    });
                });
        }
        if (isMobile && !useListingPageLite && !this.ListingPageMobile) {
            /* istanbul ignore next */
            import('../ListingPage/ListingPageMobile')
                .then((component) => {
                    this.ListingPageMobile = component.default;
                    this.setState({mobileLoaded: true});
                })
                .catch((error) => {
                    log({
                        error: `Failed to load ListingPageMobile. Error Message: ${error.message}`
                    });
                });
        }
        if (isMobile === false && !this.ListingPageDesktop) {
            /* istanbul ignore next */
            import('../ListingPage/ListingPageDesktop')
                .then((component) => {
                    this.ListingPageDesktop = component.default;
                    this.setState({desktopLoaded: true});
                })
                .catch((error) => {
                    log({
                        error: `Failed to load ListingPageDesktop. Error Message: ${error.message}`
                    });
                });
        }
    }

    // eslint-disable-next-line complexity
    render() {
        const {listingPageComponent: ListingPageComponent, ...rest} = this.props;
        const {system} = rest;
        const {isMobile, useListingPageLite} = system;
        const {ListingPageMobile, ListingPageMobileLite, ListingPageDesktop} = this;

        if (
            !this.loaded ||
            (isMobile && useListingPageLite && !this.state.mobileLiteLoaded) ||
            (isMobile && !useListingPageLite && !this.state.mobileLoaded) ||
            (!isMobile && !this.state.desktopLoaded)
        ) {
            return <ListingPageComponent {...rest} />;
        }

        return (
            (isMobile && useListingPageLite && <ListingPageMobileLite {...rest} />) ||
            (isMobile && <ListingPageMobile {...rest} />) || <ListingPageDesktop {...rest} />
        );
    }
}

export default ListingPageAll;
